import { ASSIGN_TRAINER } from "../../actions/trainer/assign_trainer_action";

const initState = {
  is_done: false,
  loading: false,
  errors: [],
  trainerList: [],
  takeCallList: [],
  requirements: []
};

const assignTrainerReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case ASSIGN_TRAINER.ERROR:
      return {
        ...state,
        loading: false,
        errors: payload,
        is_done: false
      };

    case ASSIGN_TRAINER.REQUEST:
      return {
        ...state,
        loading: true,
        is_done: false,
        errors: [],
        //   trainerList: [],
        takeCallList: []
      };

    case ASSIGN_TRAINER.CREATE_TAKE_CALL:
      return {
        ...state,
        loading: false,
        is_done: true,
        errors: []
      };

    case ASSIGN_TRAINER.GET_TRAINER_LIST:
      return {
        ...state,
        loading: false,
        is_done: true,
        errors: [],
        trainerList: payload
      };

    case ASSIGN_TRAINER.SHOW_TAKE_CALL:
      return {
        ...state,
        loading: false,
        is_done: false,
        errors: [],
        list: [],
        takeCallList: payload
      };

    case ASSIGN_TRAINER.SHOW_TAKE_CALL_DETAILS:
    case ASSIGN_TRAINER.TRAINER_TAKE_CALLS:
      return {
        ...state,
        loading: false,
        is_done: false,
        errors: [],
        list: payload
      };

    case ASSIGN_TRAINER.ASSIGN_TRAINER_TO_TRAINING:
    case ASSIGN_TRAINER.RESCHEDULE_TAKE_CALL:
    case ASSIGN_TRAINER.RESCHEDULE_TRAINER_TAKE_CALL:
    case ASSIGN_TRAINER.UPDATE_TRAINER_TRANING_REQUIREMENT:
      return {
        ...state,
        loading: false,
        is_done: true,
        errors: []
      };
    case ASSIGN_TRAINER.GET_TRANING_REQUIREMENT:
    case ASSIGN_TRAINER.GET_TRANING_TRAINER_REQUIREMENT_STATUS:
      return {
        ...state,
        loading: false,
        is_done: false,
        errors: [],
        requirements: payload
      };
    default:
      return state;
  }
};

export default assignTrainerReducer;
